import { render } from "./BillingPanel.vue?vue&type=template&id=5136f95c&scoped=true"
import script from "./BillingPanel.vue?vue&type=script&lang=js"
export * from "./BillingPanel.vue?vue&type=script&lang=js"

import "./BillingPanel.vue?vue&type=style&index=0&id=5136f95c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5136f95c"]])

export default __exports__